export default {
    "请输入群聊名称": "请输入群聊名称",
    "等待对方接听...": "等待对方接听...",
    "强制下线通知": "强制下线通知",
    "您已在其他地方登录，将被强制下线": "您已在其他地方登录，将被强制下线",
    "初始化失败": "初始化失败",
    "【回执消息】": "【回执消息】",
    "你撤回了一条消息": "你撤回了一条消息",
    "申请直播权限": "申请直播权限",
    "重新申请直播权限": "重新申请直播权限",
    "请先绑定手机号": "请先绑定手机号",
    "分享链接复制成功，请粘贴至分享处!": "分享链接复制成功，请粘贴至分享处!",
    "分享失败!": "分享失败!",
    "商品已被收藏": "商品已被收藏",
    "IM 初始化失败": "IM 初始化失败",
    "消息服务连接失败": "消息服务连接失败",
    "加载中...": "加载中...",
    "正在录音...": "正在录音...",
    "长按 说话": "长按 说话",
    "松手取消": "松手取消",
    "不能发送空白信息": "不能发送空白信息",
    " @全体成员": " @全体成员",
    "[有人@我]": "[有人@我]",
    "[@全体成员]": "[@全体成员]",
    "停止": "停止",
    "播放音频出错": "播放音频出错",
    "确认删除消息?": "确认删除消息?",
    "删除消息": "删除消息",
    "退出群聊后将不再接受群里的消息，确认退出吗？": "退出群聊后将不再接受群里的消息，确认退出吗？",
    "确认退出?": "确认退出?",
    "确认解除?": "确认解除?",
    "修改成功": "修改成功",
    "webrtc连接成功": "webrtc连接成功",
    "消息接收中...": "消息接收中...",
    "置顶": "置顶",
    "待签约": "待签约",
    "已签约": "已签约",
    "店铺充值": "店铺充值",
    "店铺保证金充值": "店铺保证金充值",
    "未开通VIP": "未开通VIP",
    "到期": "到期",
    "选择支付方式": "选择支付方式",
    "处理中...": "处理中...",
    "更换": "更换",
    "金额不对": "金额不对",
    "正在拼团": "正在拼团",
    "成功团": "成功团",
    "失败团": "失败团",
    "我的代金券": "我的代金券",
    "我的拼团": "我的拼团",
    "您已在其他设备登录，将被强制下线": "您已在其他设备登录，将被强制下线",
    "相册": "相册",
    "拍摄": "拍摄",
    "填写资质材料": "填写资质材料",
    "请选择开始时间（含时分秒）": "请选择开始时间（含时分秒）",
    "请选择结束时间（含时分秒）": "请选择结束时间（含时分秒）",
    "暂未分配": "暂未分配",
    "正在初始化页面,请稍后...": "正在初始化页面,请稍后...",
    "退出登录": "退出登录",
    "暂无优惠券": "暂无优惠券",
    "暂无品牌": "暂无品牌",
    "关闭广告": "关闭广告",
    "手机访问": "手机访问",
    "中文繁體": "中文繁體",
    "中文简体": "中文简体",
    "日本語": "日本語",
    "预览": "预览",
    "大小不超过": "大小不超过",
    "格式为": "格式为",
    "群聊信息": "群聊信息",
    "表情": "表情",
    "发送图片": "发送图片",
    "发送文件": "发送文件",
    "回执消息": "回执消息",
    "发送语音": "发送语音",
    "语音通话": "语音通话",
    "语音通话": "语音通话",
    "视频通话": "视频通话",
    "聊天记录": "聊天记录",
    "`已读(${readedMembers.length})`": "`已读(${readedMembers.length})`",
    "`未读(${unreadMembers.length})`": "`未读(${unreadMembers.length})`",
    "搜索群成员": "搜索群成员",
    "邀请好友进群聊": "邀请好友进群聊",
    "群聊名称": "群聊名称",
    "群主": "群主",
    "群公告": "群公告",
    "我在本群的昵称": "我在本群的昵称",
    "邀请": "邀请",
    "保存": "保存",
    "退出群聊": "退出群聊",
    "聊天历史记录": "聊天历史记录",
    "群": "群",
    "发送失败": "发送失败",
    "发送失败": "发送失败",
    "重新呼叫": "重新呼叫",
    "重新呼叫": "重新呼叫",
    "全体已读": "全体已读",
    "已读": "已读",
    "未读": "未读",
    "语音录制": "语音录制",
    "开始录音": "开始录音",
    "暂停录音": "暂停录音",
    "继续录音": "继续录音",
    "重新录音": "重新录音",
    "立即发送": "立即发送",
    "用户当前在线": "用户当前在线",
    "BizSpring 提供技术支持": "BizSpring 提供技术支持",
    "BizSpring 提供技术支持": "BizSpring 提供技术支持",
    "签名": "签名",
    "发消息": "发消息",
    "加为好友": "加为好友",
    "添加好友": "添加好友",
    "输入用户名或昵称按下enter搜索，最多展示20条": "输入用户名或昵称按下enter搜索，最多展示20条",
    "发送消息": "发送消息",
    "添加": "添加",
    "已添加": "已添加",
    "电脑设备在线": "电脑设备在线",
    "移动设备在线": "移动设备在线",
    "邀请好友": "邀请好友",
    "搜索好友": "搜索好友",
    "取 消": "取 消",
    "确 定": "确 定",
    "选择成员": "选择成员",
    "取 消": "取 消",
    "确 定": "确 定",
    "连接中...": "连接中...",
    "是否加入通话?": "是否加入通话?",
    "取 消": "取 消",
    "确 定": "确 定",
    "语音通话": "语音通话",
    "接受": "接受",
    "拒绝": "拒绝",
    "头像": "头像",
    "个性签名": "个性签名",
    "取 消": "取 消",
    "确 定": "确 定",
    "添加好友": "添加好友",
    "好友信息": "好友信息",
    "签名": "签名",
    "发消息": "发消息",
    "加为好友": "加为好友",
    "删除好友": "删除好友",
    "创建群聊": "创建群聊",
    "群聊名称": "群聊名称",
    "群主": "群主",
    "群名备注": "群名备注",
    "我在本群的昵称": "我在本群的昵称",
    "群公告": "群公告",
    "群主未设置": "群主未设置",
    "邀请好友进群聊": "邀请好友进群聊",
    "邀请": "邀请",
    "保存": "保存",
    "解散": "解散",
    "邀请": "邀请",
    "终端": "终端",
    "登录1": "登录1",
    "没有账号,前往注册": "没有账号,前往注册",
    "电话": "电话",
    "电话": "电话",
    "尊称": "尊称",
    "尊称": "尊称",
    "公司名称": "公司名称",
    "公司名称": "公司名称",
    "已有账号,前往登录": "已有账号,前往登录",
    "电话": "电话",
    "电话": "电话",
    "尊称": "尊称",
    "尊称": "尊称",
    "公司名称": "公司名称",
    "公司名称": "公司名称",
    "请填写您的信息": "请填写您的信息",
    "开始咨询": "开始咨询",
    "已有账号,前往登录": "已有账号,前往登录",
    "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）": "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）",
    "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）": "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）",
    "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）": "🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）",
    "秒杀": "秒杀",
    "运费": "运费",
    "团购商品": "团购商品",
    "甄选商品": "甄选商品",
    "请选择用户等级": "请选择用户等级",
    "当前地区": "当前地区",
    "分享": "分享",
    "店铺类型": "店铺类型",
    "商品合计金额": "商品合计金额",
    "赠送积分": "赠送积分",
    "促销折扣": "促销折扣",
    "优惠券折扣": "优惠券折扣",
    "积分抵现": "积分抵现",
    "积分抵现": "积分抵现",
    "使用积分抵扣": "使用积分抵扣",
    "确定支付订单？": "确定支付订单？",
    "已关闭": "已关闭",
    "获取验证码": "获取验证码",
    "请输入验证码": "请输入验证码",
    "发送":"发送",
    "验证码":"验证码",
    "已发送，请注意查收": "已发送，请注意查收",
    "联系商家": "联系商家",
    "请输入完整的支付密码!" : "请输入完整的支付密码!",
    "加值": "加值",
    "银行卡": "银行卡",
    "平台人工发起退款": "平台人工发起退款",
    "提领": "提领",
    "用户未发表评论": "用户未发表评论",
    '订单': '订单',
    '下单成功，等待付款': '下单成功，等待付款',
    '下单成功，付款成功': '下单成功，付款成功',
    '已发货，正在运输中': '已发货，正在运输中',
    '订单已取消，原因:手动发起取消订单': '订单已取消，原因:手动发起取消订单',
    '订单已取消，原因:超时自动取消订单': '订单已取消，原因:超时自动取消订单',
    "长时间未付款，系统自动取消订单": "长时间未付款，系统自动取消订单",
    '商家已确认，已进入备货状态': '商家已确认，已进入备货状态',
    '系统发货成功': '供应商发货成功',
    '订单已签收': '订单已签收',
    '发起退款申请': '发起退款申请',
    '退款成功': '退款成功',
    '退款失败': '退款失败',
    '订单退款成功': '订单退款成功',
    '订单退款失败': '订单退款失败',
    '系统默认好评': '系统默认好评',
    "请输入关键字搜索": "请输入关键字搜索",
    '充值金额不能小于1': '格式有误:充值金额不能小于1(包含俩位小数)',
    "猜你喜欢": "猜你喜欢",
    "订单已完成": "订单已完成",
    "热销推荐": "热销推荐",
    "头像选择": "头像选择",
    "修改头像": "修改头像",
    "加密货币": "加密货币",
    "银行卡": "银行卡",
    "充值币种": "充值币种",
    '参数缺失': '参数缺失',
    '充值数量必填': '充值数量必填',
    "充值金额": "充值金额",
    "充值金额不得小于": "充值金额不得小于",
    "充值金额不得大于": "充值金额不得大于",
    "请先选择币种": "请先选择币种",
    "开户行": "开户行",
    "请输入开户行名称": "请输入开户行名称",
    "银行卡号": "银行卡号",
    "请输入银行卡号": "请输入银行卡号",
    "点击去支付": "点击去支付",
    "企业证明": "企业证明",
    order: {
        cancel: '取消订单',
        payment: '立即付款',
        remind: '提醒发货',
        return: '申请退货',
        confirm: '确认收货',
        evaluate: '立即评价',
        logistics: '查看物流',
        noRefund: '未退款',
        refunding: '退款中',
        refundSuccess: '退款成功',
        refundFail: '退款失败',
        expressCompany: '快递公司',
        trackingNo: '运单号',
        noOrderShipping: '暂无物流单号',
        noTransitSteps: '暂无轨迹信息',
        logisticsLoadFail: '物流查询失败，请稍后重试'
    },
    cancelOrderMap: {
        0: "不想要了",
        1: '下错商品',
        2: '订单重复',
        3: '无法签收',
        4: '其他原因',
    },
    "1": "下错商品",
        "2": "订单重复",
        "3": "无法签收",
        "4": "其他原因",
        "KEY": "中文简体(cn)",
        "-连接已建立-": "-连接已建立-",
        ",才可提币": ",才可提币",
        "[code]值错误": "[code]值错误",
        "[symbol]参数为空": "[symbol]参数为空",
        "goodsFreightTips1": "1、跨境商品运费构成：运费=派送费+长途运费+送货费",
        "creditQuotaINFO": "100,000至30,000,000，额度灵活， 没有限制，最长贷款期限一年。",
        "authentic": "100% 正品",
        "homeIconTips1": "100%正品",
        "goodsFreightTips2": "2、如不满足包邮条件，按实际收取运费产品",
        "goodsFreightTips3": "3、最终解释权归平台所有",
        "dayReturns7": "7 天退货",
        "homeIconTips2": "7天退货",
        "homeIconTips4": "安全付款",
        "safe": "安全无忧",
        "safePayment": "安全支付",
        "homeDownloadtips4": "商城App",
        "homeDownloadtips41": "商家App",
        "keep": "保持",
        "saveQr": "保存二维码",
        "payPal": "贝宝",
        "coinBlock": "币种协议",
        "validatorRequire": "必填项不能为空",
        "edit": "编辑",
        "markDefaultAddress": "标记为默认送货地址",
        "不能为空": "不能为空",
        "cancelOrder2": "不喜欢，不想要",
        "contactUs1": "不想向同学朋友开口借钱，请找我们。",
        "": "",
        "不在交易时段": "不在交易时段",
        "不在可提现时间内": "不在可提现时间内",
        "猜你喜欢": "猜你喜欢",
        "paramError": "参数错误",
        "参数错误": "参数错误",
        "参数异常，消息获取失败": "参数异常，消息获取失败",
        "Operate": "操作",
        "operationSuccess": "操作成功",
        "操作成功": "操作成功",
        "操作类型不能小于0": "操作类型不能小于0",
        "操作类型不是整数": "操作类型不是整数",
        "操作类型为空": "操作类型为空",
        "view": "查看",
        "Checkorder": "查看订单",
        "logistics": "查看物流",
        "CheckDetails": "查看详情",
        "lowOpinion": "差评",
        "产品不存在": "产品不存在",
        "产品剩余数量不足": "产品剩余数量不足",
        "interest": "产生利息",
        "dealSuccess": "成功",
        "successTips": "成功",
        "beSeller": "成为商家",
        "homeBannertips1": "成为商家",
        "承兑商不存在": "承兑商不存在",
        "orderCity": "城市",
        "city": "城市",
        "程序错误": "程序错误",
        "持有币种不足": "持有币种不足",
        "recharge": "充值",
        "rechargeSuccessful": "充值成功",
        "rechargeAddress": "充值地址",
        "rechargeMethod": "充值方式",
        "rechargeRecord": "充值记录",
        "充值价值不得大于最大限额": "充值价值不得大于最大限额",
        "充值价值不得小于最小限额": "充值价值不得小于最小限额",
        "充值金额不能小于1": "充值金额不能小于1(包含俩位小数)",
        "企业电话": "企业电话",
        "职业机会": "职业机会",
        "充值链错误": "充值链错误",
        "rechargeNum": "充值数量",
        "充值数量不能小于等于0": "充值数量不能小于等于0",
        "rechargeTips": "充值提示：“请如实填写实际转账金额，否则可能导致系统审核不通过，影响充值进度。",
        "dealing": "处理中",
        "processing": "处理中",
        "ship": "船",
        "creditText1": "创业贷款 解决借钱的烦恼",
        "businessloan": "创业贷款申请填写",
        "存在不同杠杆的持仓单": "存在不同杠杆的持仓单",
        "cancelOrder7": "存在质量问题",
        "存在重复的角色名称": "存在重复的角色名称",
        "大于最大采购数量": "大于最大采购数量",
        "代理层级错误": "代理层级错误",
        "delivered": "待发货",
        "pendingPayment": "待付款",
        "待付款的订单无法放行": "待付款的订单无法放行",
        "comment": "待评价",
        "receipt": "待收货",
        "pending": "待支付",
        "loanHistory": "贷款记录",
        "rates": "贷款利率",
        "term": "贷款期限",
        "application": "贷款申请",
        "creditWorry": "贷款无忧",
        "orderUnitprice": "单价",
        "当前地址格式错误": "当前地址格式错误",
        "当前订单不为待付款状态，无法取消": "当前订单不为待付款状态，无法取消",
        "当前还需交易": "当前还需交易",
        "currentRate": "当前汇率",
        "sure": "当然",
        "当日才可申购": "当日才可申购",
        "当日可提现次数不足": "当日可提现次数不足",
        "receivedAddress": "到账地址",
        "orderAddress": "地址",
        "登陆密码不符合设定": "登陆密码不符合设定",
        "登陆密码长度不符合设定": "登陆密码长度不符合设定",
        "login": "登录",
        "loginIn": "登录",
        "signIn": "登录",
        "loginSuccess": "登录成功",
        "登录过期，请重新登录": "登录过期，请重新登录",
        "LoginPassword": "登录密码",
        "登录密码必须6-12位": "登录密码必须6-12位",
        "登录密码不能为空": "登录密码不能为空",
        "登录失败": "登录失败",
        "clickUpload": "点击上传",
        "phoneNumber": "电话号码",
        "电话号码已绑定": "电话号码已绑定",
        "电话号码已绑定其他用户": "电话号码已绑定其他用户",
        "email": "电子邮件",
        "shopCollection": "店铺收藏",
        "订单": "订单",
        "trackOrder": "订单",
        "订单不存在": "订单不存在",
        "orderTrack": "订单查询",
        "serialNumber": "订单号",
        "orderSummary": "订单汇总",
        "cancelOrderSuccess": "订单取消成功",
        "订单退款成功": "订单退款成功",
        "订单退款失败": "订单退款失败",
        "orderDetails": "订单详情",
        "orderInfo": "订单信息",
        "订单已签收": "订单已签收",
        "订单已取消": "订单已取消",
        "订单已取消，无法放行": "订单已取消，无法放行",
        "订单已取消，原因:超时自动取消订单": "订单已取消，原因:超时自动取消订单",
        "订单已取消，原因:手动发起取消订单": "订单已取消，原因:手动发起取消订单",
        "订单已完成": "订单已完成",
        "订单已完成，无法放行": "订单已完成，无法放行",
        "moneyOrderStatus": "订单状态",
        "orderPrefix": "订单总额",
        "subscription": "订阅",
        "aboutText2": "额度: 100,000至30,000,000，利息低 还款方式灵活，无任何前期费用，线上放款，不打审核电话，信息保密， 当天放款。",
        "additional": "额外的",
        "evaluateOrderSuccess": "发表评价成功",
        "goodsShip": "发货",
        "发起退款申请": "发起退款申请",
        "send": "发送",
        "发现新版本，请升级到最新版本": "发现新版本，请升级到最新版本",
        "visitStore": "访问商店",
        "collAccount": "放款方式",
        "loanMethod": "放款方式",
        "classification": "分类",
        "服务器错误": "服务器错误",
        "服务器错误(500)": "服务器错误(500)",
        "servicePolicy": "服务政策",
        "PaymentOrder": "付款单",
        "uploadTips": "付款证明（上传付款明细截图）",
        "copy": "复制",
        "copySuccess": "复制成功",
        "该产品未上架": "该产品未上架",
        "该产品已上市，无法购买": "该产品已上市，无法购买",
        "该订单已取消": "该订单已取消",
        "remindRepeat": "该订单已提醒过啦~",
        "该广告剩余数量不足": "该广告剩余数量不足",
        "该基金尚未开放购买": "该基金尚未开放购买",
        "该基金尚已封闭": "该基金尚已封闭",
        "productAvailable": "该商品已下架",
        "该邮箱已被订阅": "该邮箱已被订阅",
        "notOpen": "该支付方式尚未对您所在的地区开放",
        "格式有误:充值金额不能小于1(包含俩位小数)": "格式有误:充值金额不能小于1(包含俩位小数)",
        "userCenter": "个人中心",
        "Item": "个商品",
        "跟单倍数输入错误": "跟单倍数输入错误",
        "跟单参数输入错误": "跟单参数输入错误",
        "more": "更多",
        "更新提醒": "更新提醒",
        "工作地址不能为空": "工作地址不能为空",
        "homeBannertips2": "共同盈利",
        "orderTotal": "共计",
        "buyHistory": "购买记录",
        "购买矿机时间不得低于托管订单剩余时间": "购买矿机时间不得低于托管订单剩余时间",
        "purchageHistory": "购买历史",
        "addCartMessageFaild": "购物车已存在该商品",
        "fixedRate": "固定利率",
        "aboutUs": "关于我们",
        "about": "关于我们",
        "followers": "关注",
        当前余额: "当前余额",
        "备注": "备注",
        "followedSuccess": "关注成功",
        "myFollowedShops": "关注店铺",
        "广告不存在": "广告不存在",
        "广告已下架": "广告已下架",
        "orderSpecification": "规格",
        "countryOf": "国籍",
        "areaCode": "国际区号",
        "orderNation": "国家",
        "nation": "国家",
        "repayment": "还款",
        "repay": "还款方式",
        "reAmount": "还款金额",
        "cycle": "还款周期",
        "loginTips": "还没有账号？",
        "noAccount": "还没有账号？",
        "NoProductSelected": "还未选择商品",
        "shipping": "航运",
        "highOpinion": "好评",
        "favorableRate": "好评率",
        "myPraiseRate": "好评率",
        "totalNum": "合计",
        "partner": "合作供应商",
        "partnersTit": "合作伙伴 - 在线借贷平台",
        "BackHome": "回到首页",
        "or": "或者",
        "freight": "货运",
        "orderFreight": "货运",
        "getCoupons": "获得您更多的优惠券",
        "基金剩余购买金额不足": "基金剩余购买金额不足",
        "quickLoan": "急速放款",
        "records": "记录",
        "proceed": "继续",
        "storeSeachTips3": "家",
        "家庭地址不能为空": "家庭地址不能为空",
        "cancelOrder4": "假冒品牌",
        "price": "价格",
        "piece": "件",
        "transactionPassword": "交易密码",
        "交易员不存在": "交易员不存在",
        "交易员不能跟随自己": "交易员不能跟随自己",
        "交易员跟随人数已满": "交易员跟随人数已满",
        "交易员未开启带单": "交易员未开启带单",
        "交易员无法跟随另一个交易员": "交易员无法跟随另一个交易员",
        "角色被用户关联，不可删除": "角色被用户关联，不可删除",
        "角色不存在": "角色不存在",
        "receiver": "接收者",
        "financial": "解决您的资金困扰",
        "successLoan": "借款成功",
        "borrow": "借款失败",
        "loanAgree": "借款协议",
        "amount": "金额",
        "金额不在购买区间": "金额不在购买区间",
        "validatorMaxNumber": "金额超过限制",
        "金额错误": "金额错误",
        "validatorChineseAndEnglish": "仅支持中英文,输入范围8-64个字符",
        "oldPassword": "旧密码",
        "旧密码不能为空": "旧密码不能为空",
        "旧密码不正确": "旧密码不正确",
        "可平仓合约张数不足": "可平仓合约张数不足",
        "service": "客服",
        "custService": "客户服务",
        "homeDownloadtips1": "跨境电商商城",
        "电商批发商场": "电商商城",
        "矿机不存在": "矿机不存在",
        "矿机未解锁，无法购买": "矿机未解锁，无法购买",
        "From": "来自",
        "历史基金无法购买": "历史基金无法购买",
        "historySearch": "历史搜索",
        "payment": "立即付款",
        "buyNow": "立即购买",
        "homeBannerbtn": "立即加入",
        "evaluate": "立即评价",
        "连续输入错误三次，请3分钟后再试": "连续输入错误三次，请3分钟后再试",
        "contactUs": "联系我们",
        "twoPawword": "两次密码不匹配",
        "creditQuota": "灵活额度",
        "retailPrice": "零售价",
        "领取成功": "领取成功",
        "pageviews": "浏览量",
        "myPageviews": "浏览量",
        "buyRules": "买家规则",
        "买入金额需要在区间内": "买入金额需要在区间内",
        "卖方无法取消该订单": "卖方无法取消该订单",
        "cancelOrder3": "卖家发错货",
        "sellerRules": "卖家政策",
        "noDataFound": "没有找到数据",
        "没有找到用户": "没有找到用户",
        "dailyNewArrival": "每日新品上架",
        "verificationCode":"验证码",
        "pleaseEnterVerificationCode":"请输入验证码",
        "pleaseEnterUsername":"请输入用户名",
        "username": "用户名",
        "password": "密码",
        "getVerificationCode":"获取验证码",
        "tryAgainLater":"秒后再试",
        "密码必须6-12位": "密码必须为6-12位",
        "密码不能为空": "密码不能为空",
        "密码不正确": "密码不正确",
        "wrongPassword": "密码错误次数超过3次, 请明日重试",
        "validatorPassword": "密码为6-12位数字或字母组成(包含特殊字符)",
        "goodsFreeShipping": "免运费",
        "orderName": "名称",
        "defaultAddress": "默认地址",
        "noCartTips": "你的购物袋是空的开始购物",
        "notLogin": "你还没有登录",
        "unSelectedProduct": "你还未选中商品",
        "evaluationUploading": "你还有正在上传的图片,请稍后再试",
        "您当前可分配额度不足": "您当前可分配额度不足",
        "yourEmail": "您的电子邮箱",
        "您没有符合条件的收款方式": "您没有符合条件的收款方式",
        "您已存在订单": "您已存在订单",
        "您已购买过体验矿机,不得重复购买": "您已购买过体验矿机,不得重复购买",
        "photoExample": "拍照示例",
        "homeDownloadtips2": "品牌特卖",
        "Evaluate": "评价",
        "evaluateOrder": "评价晒单",
        "evaluateInput": "评价晒图",
        "homeDownloadtips5": "苹果下载",
        "cancelOrder9": "其他原因",
        "businessPhone": "企业电话",
        "businessEmail": "企业邮箱",
        "walletHistory": "钱包历史",
        "亲属地址不能为空": "亲属地址不能为空",
        "亲属电话不能为空": "亲属电话不能为空",
        "亲属关系不能为空": "亲属关系不能为空",
        "亲属姓名不能为空": "亲属姓名不能为空",
        "empty": "清空",
        "evaluateOrderPlaceholder": "请对评商品做出评价",
        "checkAgreement": "请勾选协议!",
        "请检查网络连接": "请检查网络连接",
        "returnDetailTips": "请评价产品",
        "switchLang": "请切换其他语言后查看",
        "请切换其他语言后查看": "请切换其他语言后查看",
        "请上传图片": "请上传图片",
        "uploadPhoto": "请上传照片",
        "请稍后再试": "请稍后再试",
        "请稍后重试": "请稍后重试",
        "pleaseSetLoginPassword": "请设置登录密码",
        "pleaseSetMobileNumber": "请设置手机号码",
        "pleaseEnterPhoneNumer": "请设置手机号码",
        "plaeseEnterInvitaionCode": "请设置邀请码",
        "pleaseEnterEmail": "请设置邮箱",
        "enterTips": "请输入",
        "pleaseInput": "请输入",
        "validatorFourMoreNumber": "请输入4位以上纯数字",
        "pleaseValidPostCode": "请输入4位以上的数字",
        "validatorSixNumber": "请输入6位纯数字",
        "请输入充值币种": "请输入充值币种",
        "plaseEnterRechargeAddress": "请输入充值地址",
        "pleaseEnterAmount": "请输入充值金额",
        "pleaseInputCorrectNumber": "请输入大于0的数字",
        "pleaseEnterAddress": "请输入地址",
        "请输入关键字搜索": "请输入关键字搜索",
        "headerSearchTips": "请输入关键字搜索",
        "pleaseEnterOldPassword": "请输入旧密码",
        "pleaseEnterPassword": "请输入密码",
        "pleaseConfirmPassword": "请再次输入密码",
        "请输入内容": "请输入内容",
        "plaseeENterConfirmPassword": "请输入确认密码",
        "pleaseEnterQuantity": "请输入数量",
        "请输入搜索关键字": "请输入搜索关键字",
        "withdrawInputTips": "请输入提币地址",
        "plaseeEnterNewPassword": "请输入新密码",
        "yourName": "请输入姓名",
        "pleaseEnterAccount": "请输入账号",
        "请输入正确的货币数量": "请输入正确的货币数量",
        "请输入正确的金额": "请输入正确的金额",
        "validatorPhone": "请输入正确的手机号",
        "pleaseValidPhone": "请输入正确的手机号码",
        "请输入正确的数量": "请输入正确的数量",
        "inpuEmailErro": "请输入正确的邮箱地址",
        "pleaseValidEmail": "请输入正确的邮箱地址",
        "validatorEmail": "请输入正确的邮箱格式",
        "请输入正确的质押金额": "请输入正确的质押金额",
        "请输入正确的质押天数": "请输入正确的质押天数",
        "pleaseCorrectAddress": "请输入正确提币地址",
        "请填写正确的电话号码": "请填写正确的电话号码",
        "请填写正确的验证码": "请填写正确的验证码",
        "mailboxCheck": "请填写正确的邮箱地址",
        "请填写正确的邮箱地址": "请填写正确的邮箱地址",
        "请先绑定谷歌验证器": "请先绑定谷歌验证器",
        "请先添加收款方式": "请先添加收款方式",
        "请先通过高级认证": "请先通过高级认证",
        "cancelOrderTitle": "请选择订单取消原因",
        "selectCountry": "请选择国籍",
        "请选择买卖方式": "请选择买卖方式",
        "selectPeriod": "请选择期限",
        "returnOrderTitle": "请选择退货理由",
        "请选择正确的币种": "请选择正确的币种",
        "请重新登录": "请重新登录",
        "blockchainNetwork": "区块链网络",
        "渠道未开通": "渠道未开通",
        "Cancel": "取消",
        "取消": "取消",
        "cancelSuccess": "取消成功",
        "cancelOrder": "取消订单",
        "cancel": "取消",
        "CancelOrder": "取消订单",
        "myUnfollow": "取消关注",
        "cancelReason": "取消原因",
        "all": "全部",
        "AllProducts": "全部商品",
        "btnSure": "确定",
        "确认": "确认",
        "entRepay": "确认还款",
        "confirmPayPaw": "确认交易密码",
        "confirmPassword": "确认密码",
        "delAllHistoryRecord": "确认删除全部历史记录？",
        "confirm": "确认收货",
        "date": "日期",
        "scanAndDown": "扫码二维码下载APP",
        "homeDownloadtips6": "扫描二维码下载APP",
        "delete": "删除",
        "sellerPanelLogin": "商家登录",
        "merchantSettled": "商家入驻",
        "businessInformation": "商家信息",
        "sellerZone": "成为商家",
        "商家已确认，已进入备货状态": "商家已确认，已进入备货状态",
        "commodity": "商品",
        "orderCommodity": "商品",
        "commodityCollection": "商品集合",
        "productDescription": "商品描述",
        "myCommodityCollection": "商品收藏",
        "goodsNumber": "商品数量",
        "goodsShipTips": "商品下单后，24小时内发货。如下单存在物流管控，订单可能被延时发货，请留意订单物流信息或联系客服",
        "productInfo": "商品信息",
        "uploadSuccess": "上传成功",
        "uploadError": "上传失败，请重试",
        "uploading": "上传中.....",
        "upNew": "上新",
        "previous": "上一步",
        "prevPage": "上一页",
        "cancelOrder5": "少发、漏发",
        "desc": "设为默认地址",
        "setAsTheDefaultAddress": "设为默认地址",
        "setUp": "设置",
        "setSuccess": "设置成功",
        "setUpPayPaw": "设置交易密码",
        "setPassword": "设置密码",
        "申购数量错误": "申购数量错误",
        "申请成功": "申请成功",
        "applyLoan": "申请贷款",
        "applicationAmount": "申请金额",
        "noSmaller": "申请金额不能小于",
        "nomax": "申请金额最大不能超过",
        "applicant": "申请人",
        "applicantDate": "申请日期",
        "return": "申请退货",
        "applicantIn": "申请中",
        "身份证已实名过!": "身份证已实名过!",
        "审核已通过": "审核已通过",
        "审核中": "审核中",
        "state": "省/州/邦",
        "dealFail": "失败",
        "fail": "失败",
        "orderTime": "时间",
        "time": "时间",
        "ActualLedger": "实际到账",
        "actualAccount": "实际账户",
        "实名认证未通过，无法进行高级认证": "实名认证未通过，无法进行高级认证",
        "confirmReceiveGoods": "是否确认收到货",
        "collect": "收藏",
        "collectionSuccess": "收藏成功",
        "wishlist": "收藏商品",
        "cancelOrder6": "收到商品破损",
        "desc5": "收货地址有误？ 联系",
        "consigneeName": "收货人姓名",
        "shippingAddress": "收件地址",
        "收款方输入错误": "收款方输入错误",
        "mobile": "手机号",
        '购物车还没有商品': "购物车还没有商品",
        '去购物': "去购物",
        "mobilePhone": "手机号码",
        "handleFee": "手续费",
        "handlingFee": "手续费",
        "home": "首页",
        "授权状态未成功": "授权状态未成功",
        "pleaseSetAreaCode": "输入国家、区号进行搜索",
        "searchCountry": "输入国家、区号进行搜索",
        "desc3": "输入交易密码",
        "desc4": "输入您的交易密码",
        "赎回状态异常": "赎回状态异常",
        "quantity": "数量",
        "orderAmount": "数量",
        "orderQuantity": "数量",
        "inputNum": "数字",
        "orderTax": "税",
        "orderFee": "税费",
        "tax": "税收",
        "delivery": "送货及取货",
        "storeSeach": "搜本店",
        "search": "搜索",
        "所选汇率不存在": "所选汇率不存在",
        "allProduct": "所有产品",
        "提币数量不能小于等于0": "提币数量不能小于等于0",
        "creditText2": "提供创业贷款 资金周转服务",
        "returnOrderSuccess": "提交成功",
        "Submitareview": "提交评论",
        "submitApplica": "提交申请",
        "提交失败": "提交失败",
        "提交失败，当前有未处理订单": "提交失败，当前有未处理订单",
        "hint": "提示",
        "提示": "提示",
        "withdraw": "提现",
        "提现不得大于限额": "提现不得大于限额",
        "提现不得小于限额": "提现不得小于限额",
        "withdrawSuccess": "订单提交成功",
        "withdrawAddress": "提现地址",
        "withdrawRecord": "提现记录",
        "withdrawNum": "提现数量",
        "tipsRemindsSuccess": "提醒成功",
        "remindSuccess": "提醒成功",
        "RemindShip": "提醒发货",
        "remind": "提醒发货",
        "remindTitle": "提醒发货",
        "tipsRemindsText": "提醒发货后，商家会收到提醒",
        "remindContent": "提醒发货后，商家会收到提醒, 只能提醒1次哟~",
        "tipsRemindsMerchant": "提醒商家",
        "days": "天",
        "addCartMessage": "添加到购物车成功",
        "addAddress": "添加地址",
        "addAddressOrModifyAddress": "添加地址/修改地址",
        "addCart": "添加购物车",
        "图片不得大于10M": "图片不得大于10M",
        "图片不得大于2M": "图片不得大于2M",
        "图片大小不能超过2M！": "图片大小不能超过2M！",
        "图片上传失败": "图片上传失败",
        "recommend": "推荐",
        "recommendedProducts": "推荐产品",
        "recommendedStore": "推荐店铺",
        "推荐码不正确": "推荐码不正确",
        "推荐人无权限推荐": "推荐人无权限推荐",
        "推荐商品": "推荐商品",
        "logout": "退出",
        "returnsAndEx": "退货和换货",
        "returnAmount": "退货金额",
        "returnRemark": "退货说明",
        "returnPolicy": "退货政策",
        "Refund": "退款",
        "refund": "退款/售后",
        "退款成功": "退款成功",
        "refundSuccessfully": "退款成功",
        "refundSuccess": "退款成功",
        "returnReason": "退款理由",
        "returnApply": "退款申请",
        "退款失败": "退款失败",
        "refundFail": "退款失败",
        "refundInstructions": "退款说明",
        "refunding": "退款中",
        "mastercard": "万事达卡",
        "EsShop": "网店",
        "ForgotPassword": "忘记密码？",
        "委托数量(张)必填": "委托数量(张)必填",
        "委托数量(张)不能小于等于0": "委托数量(张)不能小于等于0",
        "foryourmoney": "为你解决资金紧张，无处借钱，不好意思向朋友开口借钱等贷款难题，全程专业人员 服务，随时解答你的疑惑不解，我们的目标是让每一笔贷款都透明化，让客户快捷放心的使用。",
        "storeSeachTips1": "为您找到",
        "未绑定谷歌验证器": "未绑定谷歌验证器",
        "未绑定手机号": "未绑定手机号",
        "未绑定邮箱": "未绑定邮箱",
        "未发现授权记录": "未发现授权记录",
        "notQua": "未满足资质条件",
        "ShippingAddressNotSet": "未设置收货地址",
        "未实名认证，是否认证？": "未实名认证，是否认证？",
        "cancelOrder1": "未收到货",
        "未授权访问": "未授权访问",
        "noRefund": "未退款",
        "未找到符合条件的匹配订单": "未找到符合条件的匹配订单",
        "未找到匹配的收益记录": "未找到匹配的收益记录",
        "mine": "我的",
        "myloan": "我的贷款",
        "myOrder": "我的订单",
        "myComment": "我的评价",
        "myPoint": "我的积分",
        "accountInfo": "账户信息",
        "myBalance": "我的预存款",
        "myCoupon": "我的优惠券",
        "unused": "未使用",
        "used": "已使用",
        "expired": "已过期",
        "expires": "有效期至",
        "minSpend": "满",
        "availableBalance": "可用余额",
        "personalDeposit": "预存款",
        "useDepositBalance": "使用预存款抵扣",
        "depositDeduct": "预存款抵扣",
        "useMaxDeposit": "全额抵扣",
        "balanceHistory": "余额记录",
        "recordCount": "共 {count} 条",
        "depositType": "业务类型",
        "balanceAfter": "结余",
        "depositTypeRecharge": "预存款充值",
        "depositTypeAdjustment": "余额调整",
        "depositTypeOrderPayment": "订单支付",
        "depositTypeOrderRefunds": "订单退款",
        "depositTypeDistributionCommission": "分销提成",
        "depositTypeDistributionWithdrawal": "分销提现",
        "depositTypeOther": "其他",
        "income": "收入",
        "expense": "支出",
        "description": "描述",
        "myFootprint": "我的足迹",
        "myCart": "我的购物车",
        "我的购物车": "我的购物车",
        "myPurse": "我的钱包",
        "myAccount": "我的帐户",
        "aboutText1": "我们致力于贷款金融服务，基于“客户至上”的经营理念，以解决客户资金周转问题为使命，公司从成立至今，已帮助无数留客户解决资金周转问题。",
        "readAndAgree": "我已阅读并同意",
        "safeInfo": "无抵押贷款，无需押金，不打回访电话， 这本就是一件私密的事。",
        "无权限": "无权限",
        "无效的UID": "无效的UID",
        "item": "物品",
        "系统参数错误": "系统参数错误",
        "系统存在相同[系统登录名]！": "系统存在相同[系统登录名]！",
        "系统错误，请稍后重试": "系统错误，请稍后重试",
        // "系统发货成功": "系统发货成功",
        "系统默认好评": "系统默认好评",
        "defaultRate": "系统默认好评",
        "checkout": "下单",
        "下单不能小于最小金额限制": "下单不能小于最小金额限制",
        "下单成功，等待付款": "下单成功，等待付款",
        "下单成功，付款成功": "下单成功，付款成功",
        "buyTips": "下单后，24小时内发货。以下订单受物流控制，可能会延迟发货。 请关注物流信息或联系客服。",
        "nextPage": "下一页",
        "stateMent": "现代奴隶声明",
        "storeSeachTips2": "相关的店铺",
        "address": "详细地址",
        "items": "项目",
        "browse": "销量",
        "sold": "销售量",
        "sales": "销售量",
        "校验IP不合法": "校验IP不合法",
        "new": "新的",
        "newPassword": "新密码",
        "新密码不能为空": "新密码不能为空",
        "新密码不一致": "新密码不一致",
        "新密码确认不能为空": "新密码确认不能为空",
        "news": "新闻资讯",
        "addNewAddress": "新增地址",
        "creditTit": "信贷服务",
        "Information": "信息",
        "行情获取异常，稍后再试": "行情获取异常，稍后再试",
        "modifyAddress": "修改地址",
        "handlingfee": "需要手续费",
        "Opt": "选择",
        "selectDeliveryAddress": "选择送货地址",
        "验证类型不能为空": "验证类型不能为空",
        "验证码不能为空": "验证码不能为空",
        "验证码不正确": "验证码不正确",
        "验证码错误": "验证码错误",
        "vcodeFail": "验证失败,请重试",
        "vcodePass": "验证通过!",
        "invitationCode": "邀请码",
        "页码不能小于等于0": "页码不能小于等于0",
        "页码不是整数": "页码不是整数",
        "dashboard": "仪表板",
        "loaned": "已贷款",
        "loanDays": "已贷款天数",
        "已发货，正在运输中": "已发货，正在运输中",
        "followed": "已关注",
        "repaid": "已还款",
        "已领取": "已领取",
        "rated": "已评价",
        "cancelled": "已取消",
        "confirmed": "已确认",
        "harvested": "已收货",
        "mySold": "已售",
        "overdue": "已逾期",
        "privacyPolicy": "隐私政策",
        "用户不存在": "用户不存在",
        "用户名必须由数字和英文字母组成": "用户名必须由数字和英文字母组成",
        "用户名不存在": "用户名不存在",
        "用户名不符合设定": "用户名不符合要求",
        "用户名不能为空": "用户名不能为空",
        "用户名参数为空": "用户名参数为空",
        "用户名重复": "用户名重复",
        "userEvaluation": "用户评价",
        "用户剩余数量不足": "用户剩余数量不足",
        "用户未发表评论": "用户未发表评论",
        "用户已跟随交易员": "用户已跟随交易员",
        "user_Center": "用户中心",
        "userReg": "用户注册",
        "postCode": "邮编",
        "orderEmail": "邮箱",
        "邮箱已绑定": "邮箱已绑定",
        "邮箱已绑定其他用户": "邮箱已绑定其他用户",
        "orderPostCode": "邮政编码",
        "hasImage": "有图",
        "Balance": "余额",
        "balance": "余额（USDT）",
        "余额不足": "余额不足",
        "balanceNot": "余额不足，请充值",
        "shop_order_insufficientBalance": "账户余额不足",
        "cancelOrder8": "与商家协商一致退款",
        "expectedArrival": "预计到货",
        "esRepayment": "预计还款",
        "estirepay": "预计还款",
        "originPrice": "原价",
        "deliveryFee": "运费",
        "goodsFreight": "运费",
        "shippingDiscounts": "运费折扣",
        "homeIconTips3": "运费折扣",
        "desc6": "再次输入您的交易密码",
        "rebuy": "再来一单",
        "onlineService": "在线服务",
        "customeService": "在线客服",
        "helpLine": "在线客服",
        "onlineApplin": "在线申请",
        "暂无店铺": "暂无店铺",
        "noComments": "暂无评价",
        "noData": "暂无数据",
        "帐户异常需要进行C3认证，请联系在线客服。": "帐户异常需要进行C3认证，请联系在线客服。",
        "account": "账户",
        "accountBalance": "账户余额",
        "accountB": "账户余额",
        "accountReview": "账户总览",
        "Recruitment": "招贤纳士",
        "找不到用户": "找不到用户",
        "searchTips": "找货源/商品/供应商/求购",
        "hotSearch": "热门搜索：",
        "discount": "折扣",
        "homeDownloadtips3": "折扣不停",
        "discounted": "折扣商品",
        "flashSale": "秒杀",
        "groupBuy": "拼团",
        "groupBuying": "拼团购",
        "couponCenter": "优惠券中心",
        "pointMall": "积分商城",
        "liveList": "直播",
        "endsIn": "距结束",
        "soldOut": "已售",
        "people": "人",
        "joined": "已参团",
        "startGroup": "开始拼团",
        "getCoupon": "领取",
        "getCouponSuccess": "领取成功",
        "liveRooms": "直播间",
        "liveStreaming": "直播中",
        "notStarted": "未开始",
        "finished": "已结束",
        "myPoints": "我的积分",
        "searchGoods": "搜索商品",
        "points": "积分",
        "point": "积分",
        "stock": "库存",
        "spec": "规格",
        "exchangeNow": "立即兑换",
        "currentPoint": "当前积分",
        "pointNotEnough": "积分不足",
        "actualName": "真实姓名",
        "passPortImg": "证件号码/护照号码",
        "uploadId": "证件照/护照上传",
        "Payment": "支付",
        "pay": "支付",
        "paymentSuccessful": "支付成功",
        "paymentMethod": "支付方式",
        "paymethods": "支付方式",
        "payCertificate": "支付凭证",
        "直线关系，不能修改推荐": "直线关系，不能修改推荐",
        "tipsRemindsCount": "只能提醒1次哟~",
        "committed": "致力于创业者贷款服务",
        "mediumOpinion": "中评",
        "sort": "种类",
        "重复提交": "重复提交",
        "Reapply": "重新申请",
        "register": "注册",
        "signUp": "注册",
        "registerSuccess": "注册成功",
        "转账币种不能为空": "转账币种不能为空",
        "转账数量不能小于等于0": "转账数量不能小于等于0",
        "orderStatus": "状态",
        "orderState": "状态",
        "状态不能小于0": "状态不能小于0",
        "状态不是整数": "状态不是整数",
        "资金密码必须6-12位": "资金密码必须为6-12位",
        "资金密码不符合设定": "资金密码不符合要求",
        "资金密码不能为空": "资金密码不能为空",
        "资金密码错误": "资金密码错误",
        "资金密码长度不符合设定": "资金密码长度不符合要求",
        "complex": "综合",
        "totalOf": "总计",
        "totalPrice": "总价",
        "homeBannertips3": "最高",
        "creditReview": "最快一小时通过审核，审核通过立即下款。",
        "yesterday": "昨天",
        "binance": "Binance",
        "huobi": "Huobi",
        "validatorIpRule": "IP格式不正确",
        "metaMask": "MetaMask",
        "footTip": "{name} 2024 版权所有",
        "footTips": "{name} Limited 作为信贷经纪人 (713206)获得金融行为监管局的授权和监管，并专门与贷方 Home Retail Group CardServices Limited 合作，以 {name} Financial Services的身份进行交易，{name} Financial Services获得金融行为监管局的授权和监管以提供信贷(716148)。Home Retail GroupCard Services Limited 注册于英国 (04007072)，地址为 Avebury, 489-499Avebury Boulevard, Milton Keynes, United Kingdom。MK9 2NW。",
        "footdec": "{name}全球站的用户来自全球{num}个国家，可以在全球范围内实现即时低成本交易，无需等待，没有国际费用。",
        "okx": "okx",
        "UID不能为空": "UID不能为空",
        "recommendclass": "推荐分类",
        "滑动验证": "滑动验证",
        "subOrder":"提交订单",
        "最多上传9张图片": "最多上传9张图片",
        "账号注销": "账号注销",
        "确定注销": "确定注销",
        "您的账号": "您的账号",
        "为什么要离开": "为什么要离开",
        "您还有余额,不能注销账号": "您还有余额,不能注销账号!",
        "请输入注销理由": "请输入注销理由!",
        "您确认要注销吗?": "您确认要注销吗?",
        "我再考虑下": "我再考虑下",
        "同意注销": "同意注销",
        "注销成功": "注销成功",
        "cancelInfo":"警告！请谨慎操作注销账户，如果您不再使用该账号，可点击【同意注销】，注销后可能几天内无法注册。",
        "App下载(买家端)": "App下载(买家端)",
        "App下载(卖家端)": "App下载(卖家端)",
        "请选择":"请选择",
        "提款地址绑定": "提款地址绑定",
        "绑定成功": "绑定成功",
        "仅能绑定一个收款地址!": "仅能绑定一个收款地址!",
        "最多包含10位小数": "最多包含10位小数",
        "footTipTikTok":"BizSpring Mall ©️2024 版权所有",
        "客户端下载":"客户端下载",
        "提现方式": "提现方式",
        "TikTokFoot":"BizSpring Mall是全球短视频社交平台BizSpring与亚洲最大的批发贸易公司Alibaba合作成立的，面向全球的电子商务平台，并在全球拥有三大自营智能仓库分别位于加拿大多伦多、美国洛杉矶及日本千叶。App内在售商品包含来自日本、韩国、中国等亚洲人气商品，目前总数已超过50,000款，并在持续快速增长中。",
        "required": "此字段必填",
        "nickname": "昵称",
        "enterNickname": "请输入昵称",
        "gender": "性别",
        "male": "男",
        "female": "女",
        "secret": "保密",
        "birthday": "生日",
        "selectDate": "选择日期",
        "seckillPrice": "秒杀价",
        "seckillTag": "秒杀",
        "seckillCountdown": "距结束",
        "seckillNotStarted": "即将开始",
        "seckillRushing": "抢购进行中",
        "seckillWillStart": "即将开始",
        "seckillBuy": "立即秒杀",
        "groupPrice": "团购价",
        "groupRequiredNum": "人成团",
        "noGroupBuy": "单独购买",
        "groupRule1": "1. 选商品",
        "groupRule2": "2. 发起拼团",
        "groupRule3": "3. 成团发货",
        "marketingMoneyOff": "满减",
        "marketingFreeShipping": "免运",
        "marketingGift": "买赠",
        "marketingCoupon": "券惠",
        "marketingGroup": "团购",
        "marketingSeckill": "秒杀",
        "alreadyGotCoupon": "已领",
        "couponReceived": "已领取",
        "marketingExpired": "活动已失效",
        "marketingNotActive": "活动未开始或已结束",
        "addImageHint": "（请添加图片）",
        "deleteNode": "删除",
        "topPos": "顶层位置 {n}",
        "col": "列 {n}",
        "pos": "位置 {n}",
        "decoType_container": "容器",
        "decoType_title": "标题文字",
        "decoType_richText": "富文本",
        "decoType_notice": "通知公告",
        "decoType_blank": "辅助留白",
        "decoType_banner": "轮播图",
        "decoType_imageSingle": "单图",
        "decoType_imageMulti": "多图",
        "decoType_video": "视频",
        "decoType_goodsRecommend": "商品推荐",
        "decoType_goodsSelection": "商品甄选",
        "decoType_seckill": "秒杀",
        "decoType_groupBuy": "拼团",
        "decoType_coupon": "优惠券",
        "decoType_searchNav": "搜索导航",
        "decoType_search": "搜索框",
        "decoType_searchBox": "搜索框",
        "decoType_categoryNav": "首页分类导航",
        "decoType_goodsCategory": "商品分类",
        "decoType_navIconRow": "导航按钮组",
        "decoType_imageScroll": "滚动图片",
        "decoType_pageBanner": "页面顶部广告",
        "decoType_tabs": "Tab切换",
        "decoType_brand": "品牌",
        "decoType_storeRecommend": "店铺推荐",
        "decoType_hotSelection": "热选爆款",
        "decoType_footerLinkGroup": "页脚链接组",
        "decoType_partnerLogoRow": "合作伙伴",
        "decoType_icpInfo": "ICP 备案",
        "decoType_topNavMenu": "顶部导航菜单",
        "decoType_logoBlock": "站点 Logo",
        "decoType_langSwitcher": "语言切换",
        "decoType_currencySwitcher": "货币切换",
        "decoType_loginBlock": "登录入口",
        "decoType_cartIcon": "购物车",
        "decoType_messageIcon": "消息图标",
        "搜索": "搜索",
        "搜索提示文字": "搜索提示文字",
        "请输入关键字": "请输入关键字",
        "请输入关键词": "请输入关键词",
        "contactInfo": "联系信息",
        "consignee": "收件人姓名",
        "phone": "电话",
        "enterName": "请输入姓名",
        "enterPhone": "请输入电话号码",
        "country": "国家",
        "province": "省/州",
        "detailAddress": "详细地址",
        "enterAddress": "请输入详细地址",
        "paymentInfo": "支付信息",
        "cardNumber": "卡号",
        "cardHolder": "持卡人姓名",
        "enterCardHolder": "请输入持卡人姓名",
        "expiryDate": "有效期",
        "cardNumberRequired": "卡号不能为空",
        "cardHolderRequired": "持卡人姓名不能为空",
        "expiryDateRequired": "有效期不能为空",
        "emailRegistered": "该邮箱已注册，您可以登录后继续结算。",
        "nameRequired": "姓名不能为空",
        "phoneRequired": "电话不能为空",
        "countryRequired": "国家不能为空",
        "addressRequired": "地址不能为空",
        "cardExpired": "银行卡已过期",
        "registerFailed": "注册失败",
        "accountExists": "账号已存在，请登录后继续",
        "operationFailed": "操作失败",
        "continueToCheckout": "继续结算",
        "emailRequired": "邮箱不能为空",
        "emailInvalid": "邮箱格式不正确",
        "中文繁體": "繁體中文",
        "中文简体": "简体中文",
        "日本語": "日文",
        "shoppingCart": "购物车",
        "selectAll": "全选",
        "goodsName": "商品名称",
        "subtotal": "小计",
        "action": "操作",
        "selected": "已选",
        "total": "合计",
        "emptyCart": "购物车为空",
        "allStores": "全部店铺",
        "searchStore": "搜索店铺",
        "viewStore": "进入店铺",
        "streamEnded": "直播已结束",
        "liveGoods": "直播商品",
        "announcements": "公告",
        "pointHistory": "积分明细",
        "type": "类型",
        "remark": "备注",
        "accountBind": "账号绑定",
        "mobileBind": "手机绑定",
        "notBound": "未绑定",
        "change": "更换",
        "bind": "绑定",
        "emailBind": "邮箱绑定",
        "enterMobile": "请输入手机号",
        "enterEmail": "请输入邮箱",
        "verifyCode": "验证码",
        "enterCode": "请输入验证码",
        "sendCode": "发送验证码",
        "codeSent": "验证码发送成功",
        "bindSuccess": "绑定成功",
        "save": "保存",
        "saveSuccess": "保存成功",
        "balancePay": "余额支付",
        "wechatPay": "微信支付",
        "alipay": "支付宝",
        "totalAmount": "总金额",
        "confirmPay": "确认支付",
        "paySuccess": "支付成功",
        "renew": "续费",
        "vipPrivileges": "VIP特权",
        "growthValue": "成长值",
        "expiry": "到期",
        "pointLottery": "积分抽奖",
        "costPoints": "消耗积分",
        "startLottery": "开始抽奖",
        "congratulations": "恭喜您",
        "betterLuckNextTime": "下次再接再厉",
        "noLottery": "暂无抽奖活动",
        "insufficientPoints": "积分不足",
        "pendingComment": "待评价",
        "commented": "已评价",
        "close": "关闭",
        "loginFail": "登录失败",
        "paymentFailed": "支付失败",
        "subscribe": "订阅",
        "confirmDelete": "确认删除?",
        "tips": "提示",
        "deleteSuccess": "删除成功"
};
